import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-segov-sigepo-spinner-std',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segov-sigepo-spinner.std.component.html',
  styleUrl: './segov-sigepo-spinner.std.component.css'
})
export class SegovSigepoSpinnerStdComponent {

  static instance: SegovSigepoSpinnerStdComponent;

  public isLoading = false;

  constructor() {
    SegovSigepoSpinnerStdComponent.instance = this;
  }

  public static show() {
    SegovSigepoSpinnerStdComponent.instance.isLoading = true;
  }

  public static hide() {
    SegovSigepoSpinnerStdComponent.instance.isLoading = false;
  }
}
